import { useGetPrimeiroAcesso } from "hooks/usuario/useGetPrimeiroAcesso";
import { usePostPrimeiroAcesso } from "hooks/usuario/usePostPrimeiroAcesso";
import NewPassword from "./NewPassword";

interface FirstAccessProps {
  urlToken: string;
}

export const FirstAccess: React.FC<FirstAccessProps> = (props) => {
  const { mutate: postPrimeiroAcesso } = usePostPrimeiroAcesso();
  const { data: username } = useGetPrimeiroAcesso(props.urlToken);

  return (
    <NewPassword urlToken={props.urlToken} username={username} requestFn={postPrimeiroAcesso} />
  );
};